import React, { useState } from 'react';
import './CustomModal.css';
import Dropdown from '../../MyComponents/Dropdown/Dropdown';
import PropTypes from 'prop-types';

const PROPERTY_STATUS = [
    { label: 'Jeddah', value: 'Jeddah' },
    { label: 'Medina', value: 'Medina' },
    { label: 'Mecca', value: 'Mecca' },
    { label: 'Riyadh', value: 'Riyadh' }
];

const PROPERTY_STATUS3 = [
    { label: 'Ready', value: 'Ready' },
    { label: 'Under construction', value: 'Under construction' },
];

const CustomModal = ({ show, onClose, onSubmit }) => {
    const [District, setDistrict] = useState('');
    const [status, setstatus] = useState('');

    const [beds, setbeds] = useState('');
    const [price, setprice] = useState('');

    if (!show) {
        return null;
    }

    const handleselectPropertyStatus = (selectedOption) => {
        setDistrict(selectedOption?.value);
    };

    const handleSelectStatus = (selectedOption) => {
        setstatus(selectedOption?.value);
    };


    const handleSubmit = () => {
        const formData = {
            District,
            status,
            price,
            beds,
        };

        if (typeof onSubmit === 'function') {
            onSubmit(formData);
        } else {
            console.error('onSubmit is not a function');
        }

        onClose();
    };

    const resetForm = () => {
        setDistrict('');
        setstatus('');
        setbeds('');
        // setPrice('');
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <div className="modal-header">
                    <span className="modal-header-title">Filter</span>
                    <span className="modal-close-icon" onClick={onClose}>
                        &times;
                    </span>
                </div>
                <Dropdown
                    options={PROPERTY_STATUS}
                    onSelect={handleselectPropertyStatus}
                    value={District}
                    placeholder="Select District"
                />
                <div style={{ marginTop: 20 }}>
                    <Dropdown
                        options={PROPERTY_STATUS3}
                        value={status}
                        onSelect={handleSelectStatus}
                        placeholder="Select Property Status"
                    />
                </div>

                <input
                    type="text"
                    value={beds}
                    onChange={(e) => setbeds(e.target.value)}
                    placeholder="Enter Number of Rooms"
                    className="modal-input"
                />
                {/* <div className="modal-row">
                    <input
                        type="text"
                        value={price}
                        onChange={(e) => setprice(e.target.value)}
                        placeholder="Price Start"
                        className="modal-input"
                    />
                    <input
                        type="text"
                        value={textInput3}
                        onChange={(e) => setTextInput3(e.target.value)}
                        placeholder="Price End"
                        className="modal-input"
                    />
                </div> */}
                <div className="modal-buttons">
                    <button onClick={handleSubmit} className="btn-submit">
                        Submit
                    </button>
                    <button onClick={resetForm} className="btn-cancel">
                        Reset
                    </button>
                </div>
            </div>
        </div>
    );
};
CustomModal.propTypes = {
    onSubmit: PropTypes.func.isRequired,
};

export default CustomModal;
